import React from 'react'
import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
} from '@hub/accordion'
import { Text } from '@hub/text'
import { Link } from '@hub/link'
import { Stack } from '@hub/stack'
import { Item } from '../types'

interface PaneAccordionProps {
  itemTitle: string
  items: Item[]
}

export const PaneAccordion: React.FC<PaneAccordionProps> = ({
  itemTitle,
  items,
}) => (
  <AccordionItem
    sx={{
      border: 'none',
      paddingTop: 'spacing-sm',
      paddingBottom: 'spacing-md',
      width: 'size-full',
    }}
  >
    <AccordionButton sx={{ padding: 0, margin: 0 }}>
      <Text tone="strong" fontSize="font-lg" align="left" sx={{ flex: 1 }}>
        {itemTitle}
      </Text>
      <AccordionIcon />
    </AccordionButton>
    <AccordionPanel>
      <Stack
        gap="spacing-lg"
        sx={{
          paddingX: 'spacing-md',
          paddingTop: 'spacing-lg',
          fontSize: 'font-sm',
          lineHeight: '16px',
        }}
      >
        {items &&
          items.map((item, i) => {
            if (!item || !('url' in item)) {
              return null
            }
            return (
              <Link
                to={item.url}
                href={item.url}
                key={i}
                onClick={item.onClick}
              >
                {item.label}
              </Link>
            )
          })}
      </Stack>
    </AccordionPanel>
  </AccordionItem>
)
